import React, { useState, useEffect } from "react";

import { useNavigate, useParams } from "react-router-dom";
import SuccessAlert from "../child/Alert/SuccessAlert";
import DengerAlert from "../child/Alert/DengerAlert";
import Loader from "./../child/Loder";
import BookingComponent from "./../HostIndividual/BookingComponent";

const ViewSpacePageLayer = () => {
  const [storageData, setStorageData] = useState("");
  const [storaeTypetitle, setStorageTitle] = useState("");
  const [storageInsulated, setStorageInsulated] = useState("");
  const [storageduration, setStorageduration] = useState("");
  const [accessType, setAccessType] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const { id } = useParams();
  const isEditMode = !!id;
  const navigate = useNavigate();
  useEffect(() => {
    if (!id) return;
    const fetchAdminData = async () => {
      const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/storageSpaceById/${id}`;
      try {
        setLoading(true);
        const authToken = localStorage.getItem("authToken");
        const response = await fetch(API_ENDPOINT, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch storage space  data");
        }

        const data = await response.json();
        console.log("storage Data...", data);
        setStorageData(data.storageSpace || "");
        setStorageTitle(data.storageSpace.storageType.title);
        setStorageInsulated(data.storageSpace.insulated.title);
        setStorageduration(
          `${data.storageSpace?.duration?.value} ${data.storageSpace?.duration?.unit}`
        );
        setAccessType(data.storageSpace?.accessType?.title);
      } catch (err) {
        setErrorMessage(err.message);
        setTimeout(() => {
          setErrorMessage("");
        }, 3000);
      } finally {
        setLoading(false);
      }
    };

    fetchAdminData();
  }, [isEditMode, id, navigate]);
  if (loading) {
    if (loading) return <Loader />;
  }
  return (
    <div className="row gy-4">
      <div className="col-lg-4">
        {successMessage && (
          <SuccessAlert
            message={successMessage}
            onClose={() => setSuccessMessage("")}
          />
        )}
        {errorMessage && (
          <DengerAlert
            message={errorMessage}
            onClose={() => setErrorMessage("")}
          />
        )}
      </div>
      <div className="col-md-12">
        <div className="card h-100">
          <div className="card-body p-24">
            <ul
              className="nav border-gradient-tab nav-pills mb-20 d-inline-flex"
              id="pills-tab"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link d-flex align-items-center px-24 active"
                  id="pills-edit-profile-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-edit-profile"
                  type="button"
                  role="tab"
                  aria-controls="pills-edit-profile"
                  aria-selected="true"
                >
                  Storage Information
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link d-flex align-items-center px-24"
                  id="pills-change-passwork-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-change-passwork"
                  type="button"
                  role="tab"
                  aria-controls="pills-change-passwork"
                  aria-selected="false"
                  tabIndex={-1}
                >
                  Booking history
                </button>
              </li>
            </ul>
            <div className="tab-content" id="pills-tabContent">
              <div
                className="tab-pane fade show active"
                id="pills-edit-profile"
                role="tabpanel"
                aria-labelledby="pills-edit-profile-tab"
                tabIndex={0}
              >
                <form action="#">
                  <div className="row">
                    <div className="col-sm-3">
                      <div className="mb-20">
                        <span>
                          <b>Title</b>
                        </span>
                        <p> {storageData.title}</p>
                      </div>
                    </div>

                    <div className="col-sm-3">
                      <div className="mb-20">
                        <span>
                          <b>SurfaceType</b>
                        </span>
                        <p> {storageData.surfaceType}</p>
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="mb-20">
                        <span>
                          <b>Insulated</b>
                        </span>

                        <p> {storageInsulated}</p>
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="mb-20">
                        <span>
                          <b>Duration</b>
                        </span>

                        <p> {storageduration}</p>
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="mb-20">
                        <span>
                          <b>Created Date </b>
                        </span>

                        <p>
                          {(() => {
                            const date = new Date(storageData.createdAt);
                            const day = String(date.getDate()).padStart(2, "0");
                            const month = String(date.getMonth() + 1).padStart(
                              2,
                              "0"
                            ); // Months are 0-indexed
                            const year = String(date.getFullYear());
                            return `${day}-${month}-${year}`;
                          })()}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-3">
                      <div className="mb-20">
                        <span>
                          <b>Price</b>
                        </span>

                        <p>${storageData.price}</p>
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="mb-20">
                        <span>
                          <b>Storage Type </b>
                        </span>
                        <p> {storaeTypetitle}</p>
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="mb-20">
                        <span>
                          <b>Accesss Type </b>
                        </span>
                        <p> {accessType}</p>
                      </div>
                    </div>

                    <div className="col-sm-3">
                      <div className="mb-20">
                        <span>
                          <b>Discloser </b>
                        </span>

                        <p> {storageData.discloser}</p>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-3">
                      <div className="mb-20">
                        <span>
                          <b>Access Rule </b>
                        </span>

                        <p> {storageData.accessRule}</p>
                      </div>
                    </div>

                    <div className="col-sm-3">
                      <div className="mb-20">
                        <span>
                          <b>SecurityDetail </b>
                        </span>

                        <p> {storageData.securityDetail}</p>
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="mb-20">
                        <span>
                          <b>Address </b>
                        </span>

                        <p> {storageData.address}</p>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-3">
                      <div className="mb-20">
                        <span>
                          <b>PostalCode </b>
                        </span>

                        <p> {storageData.postalCode}</p>
                      </div>
                    </div>
                    {storageData.storageStatus === "rejected" && (
                      <div className="col-sm-3">
                        <div className="mb-20">
                          <span>
                            <b>Reason </b>
                          </span>
                          <p>{storageData.reason}</p>
                        </div>
                      </div>
                    )}
                    <div className="col-sm-3">
                      <div className="mb-20">
                        <span>
                          <b>Storage Status </b>
                        </span>
                        <p> {storageData.storageStatus}</p>
                      </div>
                    </div>
                    <div
                      className={
                        storageData.storageStatus === "rejected"
                          ? "col-sm-3"
                          : "col-sm-2"
                      }
                    >
                      <div className="mb-20">
                        <span>
                          <b>Status </b>
                        </span>

                        <p> {storageData.status}</p>
                      </div>
                    </div>
                  </div>
                  {storageData.length && (
                    <>
                      <div className="row">
                        <strong>
                          <u>Dimensions Detail:-</u>
                        </strong>
                      </div>
                      <div className="row">
                        <div className="col-sm-3">
                          <div className="mb-20">
                            <span>
                              <b>Length </b>
                            </span>
                            <p>
                              {storageData.length.value}{" "}
                              {storageData.length.unit}
                            </p>
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <div className="mb-20">
                            <span>
                              <b>Width </b>
                            </span>
                            <p>
                              {storageData.width.value} {storageData.width.unit}
                            </p>
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <div className="mb-20">
                            <span>
                              <b>Height </b>
                            </span>
                            <p>
                              {storageData.height.value}{" "}
                              {storageData.height.unit}
                            </p>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {storageData.hostDetails && (
                    <>
                      <div class="row">
                        <strong>
                          <u>Host Detail:-</u>
                        </strong>
                      </div>
                      <div class="row">
                        <div className="col-sm-3">
                          <div className="mb-20">
                            <span>
                              <b>BusinessName </b>
                            </span>
                            <p> {storageData.hostDetails.businessName}</p>
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <div className="mb-20">
                            <span>
                              <b>BusinessEmail</b>
                            </span>
                            <p> {storageData.hostDetails.email}</p>
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <div className="mb-20">
                            <span>
                              <b>Email </b>
                            </span>
                            <p> {storageData.hostDetails.email}</p>
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <div className="mb-20">
                            <span>
                              <b>FirstName </b>
                            </span>
                            <p> {storageData.hostDetails.firstName}</p>
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <div className="mb-20">
                            <span>
                              <b>LastName </b>
                            </span>
                            <p> {storageData.hostDetails.lastName}</p>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {storageData.storageSpacePhoto && (
                    <>
                      <div className="row">
                        <strong>
                          <u>Image:-</u>
                        </strong>
                      </div>
                      <div className="row">
                        {storageData.storageSpacePhoto.length > 0 ? (
                          storageData.storageSpacePhoto.map((item, index) => (
                            <div className="col-sm-1" key={index}>
                              <div className="mb-20">
                                <img
                                  src={item}
                                  width="100px"
                                  height="100px"
                                  alt={`Image ${index + 1}`}
                                />
                              </div>
                            </div>
                          ))
                        ) : (
                          <p>No images available</p>
                        )}
                      </div>
                    </>
                  )}
                </form>
              </div>
              <div
                className="tab-pane fade"
                id="pills-change-passwork"
                role="tabpanel"
                aria-labelledby="pills-change-passwork-tab"
                tabIndex="0"
              >
                <BookingComponent bookingData="storagespace"></BookingComponent>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewSpacePageLayer;
